/**
 * Является ли бразуер IE8-IE11
 * @return {Boolean}
 */
export var isIE = function isIE() {
  return Boolean(document && document.documentMode);
};